<div
  class="w-full h-screen flex items-center justify-center space-y-4 flex-col"
>
  <span
    nz-icon
    nzType="stop"
    class="!text-5xl !text-danger"
    nzTheme="outline"
  ></span>
  <span class="text-center">Bạn không có quyền vào trang này!</span>
  <div class="flex items-center space-x-4">
    <a nz-button [href]="idUrl" nzType="primary">Tài khoản</a>
    <button (click)="logout()" nz-button nzType="primary" nzDanger class="!bg-myRed !border-0">
      Đăng xuất
    </button>
  </div>
</div>
